import { TCommunication } from "~/types";
import { baseService } from "../base";
import { PaginationParams, PaginationResponse } from "../type";
import { CreateCommunicationParams } from "./communication.types";

export const communicationServices = {
  getCommunicationHistory: async (params?: PaginationParams) => {
    const { data } = await baseService.get<PaginationResponse<TCommunication>>(
      "/communications",
      {
        params,
      }
    );
    return data;
  },
  createCommunication: async (data: CreateCommunicationParams) => {
    const response = await baseService.post<TCommunication>(
      "/communications",
      data
    );
    return response.data;
  },
};
